// Single source of truth for user-facing labels of roles and task statuses.
// Underlying keys are unchanged so the backend, MongoDB documents, and any
// existing logic keep working.

export const ROLE_LABEL = {
  admin: "Admin",
  assigner: "Assigner",
  checker: "Copy Editor",
  worker: "Producer",
  video_editor: "Video Editor",
  graphic_designer: "Graphic Designer",
  publisher: "Publisher",
};

export const STATUS_LABEL = {
  todo: "Assigned",
  doing: "With Producer",
  with_editor: "With Video Editor",
  to_be_checked: "With Copy Editor",
  checked: "Ready to be Published",
  done: "Published",
};

export const ROLE_OPTIONS = [
  { value: "admin", label: ROLE_LABEL.admin },
  { value: "assigner", label: ROLE_LABEL.assigner },
  { value: "worker", label: ROLE_LABEL.worker },
  { value: "video_editor", label: ROLE_LABEL.video_editor },
  { value: "graphic_designer", label: ROLE_LABEL.graphic_designer },
  { value: "checker", label: ROLE_LABEL.checker },
  { value: "publisher", label: ROLE_LABEL.publisher },
];

export function roleLabel(role) {
  return ROLE_LABEL[role] || role;
}

export function statusLabel(status) {
  return STATUS_LABEL[status] || status;
}
